import AdminPanel from './AdminPanel';
import AddCBO from './components/AddCBO';
import CredentialedCBOs from './components/CredentialedCBOs';
import EligibleEnrollees from './components/EligibleEnrollees';
import ModifyCBO from './components/ModifyCBO';

export default AdminPanel;
export { AddCBO, CredentialedCBOs, EligibleEnrollees, ModifyCBO };
